(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codae-preorder-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TZ = 'America/Toronto';

  // Wall-clock parts of a moment in Eastern Time.
  var partsFmt = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, hourCycle: 'h23',
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric', weekday: 'short'
  });
  var WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function etParts(ms) {
    var p = {};
    partsFmt.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return {
      y: +p.year, mo: +p.month, d: +p.day,
      h: +p.hour, mi: +p.minute, s: +p.second,
      wd: WEEKDAYS[p.weekday]
    };
  }

  // UTC ms for an Eastern wall-clock time (handles EST/EDT).
  function etToUtc(y, mo, d, h, mi) {
    var guess = Date.UTC(y, mo - 1, d, h, mi);
    for (var i = 0; i < 2; i++) {
      var p = etParts(guess);
      var shown = Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi);
      guess += Date.UTC(y, mo - 1, d, h, mi) - shown;
    }
    return guess;
  }

  // Next close at or after now: this week's close day, or next week's if it has passed.
  function nextClose(closeDay, hh, mm) {
    var now = Date.now();
    var p = etParts(now);
    var add = (closeDay - p.wd + 7) % 7;
    var target = etToUtc(p.y, p.mo, p.d + add, hh, mm);
    if (target <= now) target = etToUtc(p.y, p.mo, p.d + add + 7, hh, mm);
    return target;
  }

  var dateFmt = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, weekday: 'long', month: 'long', day: 'numeric',
    hour: 'numeric', minute: '2-digit'
  });

  function init(el) {
    if (el.__codaeCountdown) return;
    el.__codaeCountdown = true;

    var closeDay = parseInt(el.getAttribute('data-close-day'), 10) || 0;
    var t = (el.getAttribute('data-close-time') || '23:59').split(':');
    var hh = parseInt(t[0], 10), mm = parseInt(t[1], 10) || 0;
    if (isNaN(hh)) hh = 23;

    var dateEl = el.querySelector('[data-cd-date]');
    var d = el.querySelector('[data-cd-days]');
    var h = el.querySelector('[data-cd-hours]');
    var m = el.querySelector('[data-cd-mins]');
    var s = el.querySelector('[data-cd-secs]');
    var deadline = 0;

    function setDeadline() {
      deadline = nextClose(closeDay, hh, mm);
      if (dateEl) dateEl.textContent = dateFmt.format(new Date(deadline)).replace(/, (\d+:\d\d)/, ' at $1') + ' ET';
    }

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) { setDeadline(); diff = deadline - Date.now(); }
      d.textContent = Math.floor(diff / 86400000);
      h.textContent = Math.floor(diff / 3600000) % 24;
      m.textContent = Math.floor(diff / 60000) % 60;
      s.textContent = Math.floor(diff / 1000) % 60;
    }

    setDeadline();
    tick();
    setInterval(tick, 1000);
  }

  function initAll() { document.querySelectorAll('[data-codae-countdown]').forEach(init); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
